import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface CreateAccountCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(): object;
    getTitleCSSStyle(): object;
    getMobileNumberCSSStyle(): object;
    getPasswordCSSStyle(): object;
    getRowDivCSSStyle(): object;
    getSignUpRowDivCSSStyle(): object;
    getRememberMeCSSStyle(): object;
    getForgotPasswordCSSStyle(): object;
    getLoginButtonCSSStyle(): object;
    getDoUHaveAccountCSSStyle(): object;
    getSignUpCSSStyle(): object;
    getCategoriesCSSStyle(): object;
}

export class CreateAccountCSSStyleImpl extends UIComponentCSSStyleImpl implements CreateAccountCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            
            borderRadius: "4px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "1px solid " + this.getResources().getColor(Colors.color_5),
            // width: "676px",
            height:"auto",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "150px",
            marginBottom: "150px"
            
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_5),
            flex: 0.68,
            // justifyContent: "left",
            // textAlign: "left",
            marginTop: "40px",
            marginBottom: "40px",
            width: '100%',
            padding: '0px 20px'
        };
    }

    getTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "left",
            // height: "40px",
            fontWeight: "bold",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_36),
            lineHeight: "40px",
            fontFamily:this.getResources().getFontFamily(),

        };
    }
    

    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
        };
    }

    getPasswordCSSStyle(): object 
    {
        return {
            marginTop: "30px",
        };
    }

    getSignUpRowDivCSSStyle(): object {
        return {
            marginTop: "30px",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "15px",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getRememberMeCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h5),
            color:this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            flex: 2
        };
    }

    getForgotPasswordCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            fontWeight: 600,
        };
    }

    getLoginButtonCSSStyle(): object 
    {
        return {
            marginTop: "50px",
            width: "180px",
        };
    }

    getDoUHaveAccountCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h5),
            color:this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
        };
    }

    getSignUpCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            paddingRight:'5px',
            height: "20px",
            letterSpacing: 0,
            fontWeight: 600,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_41),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            cursor: "pointer"
        };
    }

    getCategoriesCSSStyle(): object 
    {
        return {
            marginTop: "43px",
            // width: "350px",
            // display: "flex",
            // position: "relative",
            // flexDirection: "row",
            // flexFlow: "row wrap",
            cursor:"pointer"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/createaccountcss.tsx